import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getHotMovies, getLatestMovies } from "@/utils/movie";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import MovieSection from "./components/MovieSection";
import TopicSection from "./components/TopicSection";

export default function Home() {
  const location = useLocation();

  usePageMeta({
    title: "大师兄影视_最新电影电视剧高清资源汇聚",
    description:
      "大师兄影视为您提供最新电影、电视剧等丰富影视资源，覆盖多种类型与题材，让您轻松浏览和发现感兴趣的影视内容。",
    keywords: "大师兄影视,影视资源,电影,电视剧,影视网站,影视大全,影视推荐",
  });

  useEffect(() => {
    if (location.hash === "#topics") {
      const el = document.getElementById("topics");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const latest = getLatestMovies(12);
  const hot = getHotMovies(6);

  return (
    <SiteLayout>
      <HeroCarousel />
      <CategoryEntry />

      <div className="bg-background-100/60">
        <MovieSection
          eyebrow="Latest"
          title="最新影视推荐"
          subtitle="按上线时间排序，第一时间发现新片新剧"
          movies={latest}
          moreTo="/category/全部"
          moreLabel="查看全部影视"
        />
      </div>

      <MovieSection
        eyebrow="Popular"
        title="热门影视精选"
        subtitle="根据播放量与热度推荐，人气口碑双丰收"
        movies={hot}
        moreTo="/category/电影"
        moreLabel="更多热门电影"
      />

      <div className="bg-background-100/60">
        <TopicSection />
      </div>
    </SiteLayout>
  );
}